/** 読み物（明朝）系コンポーネント共通のフォント */
export const SERIF_FONT = '"Noto Serif JP", "游明朝", "YuMincho", serif';
